exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".silentbox-item{cursor:pointer;display:inline-block;text-decoration:underline}", ""]);

// exports
